import Crud from '../components/Company/Crud'

let routes = {
    path: '/companies',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/companies/:operation?/:id?',
          name: 'Empresas',
          component: Crud
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/company.js